import { apiClient } from '@src/services/http-common'
export interface JwtToken {
  jwt: string
}

export function signIn(data: JwtToken) {
  return apiClient.post<JwtToken>('/GenerateJwtToken', data)
}
